import styles from './Captcha.module.css';
import { useState, useRef, useEffect } from 'react';
import { useHttp } from '../../hooks/http.hook';
import { Button, Input } from 'antd';

export const Captcha = ({ onCaptchaChange }) => {
  const [captchaText, setCaptchaText] = useState('');
  const [captchaSvg, setCaptchaSvg] = useState('');
  const [isValid, setIsValid] = useState(null);
  const captchaInputRef = useRef(null);

  const { request } = useHttp();

  const fetchCaptcha = async () => {
    try {
      const response = await request('api/captcha/generate');

      setCaptchaSvg(response);

      setCaptchaText('');
      setIsValid(null);
      onCaptchaChange(false);
    } catch (error) {
      console.error('Error fetching captcha:', error);
    }
  };

  const validateCaptcha = async () => {
    try {
      const response = await request('api/captcha/check', 'POST', {
        userText: captchaText,
      });

      if (!response.checkResult) {
        console.error('Something went wrong... Try again');
      }

      setIsValid(response.checkResult);
      onCaptchaChange(response.checkResult);
    } catch (error) {
      console.error('Error validating captcha:', error);
      await fetchCaptcha();
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const handleRefresh = () => {
    fetchCaptcha();
    captchaInputRef.current.focus();
  };

  const handleSubmit = e => {
    e.preventDefault();
    validateCaptcha();
  };

  return (
    <div className={styles.captchaContainer}>
      <h3>Подтвердите, что вы не робот</h3>

      <div className={styles.captchaImage} dangerouslySetInnerHTML={{ __html: captchaSvg }} />

      <div className={styles.captchaFooter}>
        <Input
          type='text'
          value={captchaText}
          onChange={e => setCaptchaText(e.target.value)}
          placeholder='Введите текст с картинки'
          ref={captchaInputRef}
        />

        <Button onClick={handleRefresh} className={styles.captchaRefresh}>
          Обновить
        </Button>
        <Button onClick={handleSubmit}>Проверить</Button>
      </div>

      {isValid === false && <p className={styles.errorText}>Неверный текст капчи. Попробуйте еще раз.</p>}
      {isValid === true && <p className={styles.successText}>Капча пройдена успешно!</p>}
    </div>
  );
};
